/**
 * @generated SignedSource<<4e7ef4eb77526e761ede14810b50fab2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type WorkspaceTodoReceiversSetTopicIdMutation$variables = {
  id: string;
  topicId?: string | null;
};
export type WorkspaceTodoReceiversSetTopicIdMutation$data = {
  readonly todoWorkspace: {
    readonly updateReceiverTopicId: {
      readonly id: string;
      readonly potentialReceiverStores: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorListItem_receiverStore">;
      }>;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly topic: {
        readonly id: string;
      } | null;
    };
  };
};
export type WorkspaceTodoReceiversSetTopicIdMutation$rawResponse = {
  readonly todoWorkspace: {
    readonly updateReceiverTopicId: {
      readonly id: string;
      readonly potentialReceiverStores: ReadonlyArray<{
        readonly id: string;
        readonly routedTeams: ReadonlyArray<{
          readonly color: string | null;
          readonly icon: TeamIcon | null;
          readonly id: string;
          readonly isPrivate: boolean;
          readonly name: string;
        } | null> | null;
        readonly store: {
          readonly id: string;
          readonly name: string;
          readonly workspaceBreadcrumbs: ReadonlyArray<string>;
        };
      }>;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly topic: {
        readonly id: string;
      } | null;
    };
  };
};
export type WorkspaceTodoReceiversSetTopicIdMutation = {
  rawResponse: WorkspaceTodoReceiversSetTopicIdMutation$rawResponse;
  response: WorkspaceTodoReceiversSetTopicIdMutation$data;
  variables: WorkspaceTodoReceiversSetTopicIdMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topicId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "topicId",
    "variableName": "topicId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgTopic",
  "kind": "LinkedField",
  "name": "topic",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "receiverStores",
  "plural": true,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoReceiversSetTopicIdMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateReceiverTopicId",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "potentialReceiverStores",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReceiverStoresSelectorListItem_receiverStore"
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoReceiversSetTopicIdMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateReceiverTopicId",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "potentialReceiverStores",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "includeExternalId",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "workspaceBreadcrumbs",
                        "storageKey": "workspaceBreadcrumbs(includeExternalId:true)"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "routedTeams",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPrivate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4a1542055aea7ad6cec28bb307ac71e7",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoReceiversSetTopicIdMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoReceiversSetTopicIdMutation(\n  $id: ID!\n  $topicId: ID\n) {\n  todoWorkspace(id: $id) {\n    updateReceiverTopicId(topicId: $topicId) {\n      id\n      potentialReceiverStores {\n        ...ReceiverStoresSelectorListItem_receiverStore\n        id\n      }\n      topic {\n        id\n      }\n      receiverStores {\n        id\n      }\n    }\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment OrgStoreWorkspaceBreadcrumbs_store on Store {\n  workspaceBreadcrumbs(includeExternalId: true)\n}\n\nfragment ReceiverStoresSelectorListItem_receiverStore on ReceiverStore {\n  store {\n    ...ReceiverStoresSelectorMain_receiverStore\n    id\n  }\n  routedTeams {\n    ...ReceiverStoresSelectorTeamsIndicator_teams\n    id\n  }\n}\n\nfragment ReceiverStoresSelectorMain_receiverStore on Store {\n  id\n  name\n  ...OrgStoreWorkspaceBreadcrumbs_store\n}\n\nfragment ReceiverStoresSelectorTeamsIndicator_teams on Team {\n  id\n  name\n  ...AHTeamIconCircle\n}\n"
  }
};
})();

(node as any).hash = "8b75f86c0b45b4ec61277ef8900887d1";

export default node;
